import { Box, IconButton, useMediaQuery } from '@mui/material';
import { closeButtonStyle, ImageContainer, ImageContainerMobile, leftArrowStylesMobileModal, leftArrowStylesModal, modalContentStyle, modalOverlayStyle, openTabButtonStyle, rightArrowStylesMobileModal, rightArrowStylesModal } from './MediaSliderStyles';
import { IArrowComponent, MediaSlides } from './types';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import CloseIcon from '@mui/icons-material/Close';
import { getOriginalWatermarkImage } from '../../lib/static/locations/fetchers';
import { useParams } from 'react-router-dom';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRigthIcon from '@mui/icons-material/ChevronRight';
interface IImageModal {
  slides: MediaSlides[];
  setOpenModal: (x: boolean) => void;
  NUMBER_OF_IMAGES_PER_SLIDE: number;
  currentIndex: number;
  setCurrentIndex: (x: number) => void;
  setCurrentIndicator: (x: number) => void;
  imageButtons?: boolean;
}

const ImageModalGallery = ({ slides, setOpenModal, NUMBER_OF_IMAGES_PER_SLIDE,
  currentIndex, setCurrentIndex, setCurrentIndicator, imageButtons=true }: IImageModal) => {
  const matchesSMbreakpoint = useMediaQuery('(max-width:768px)');
  const { id } = useParams();
  const goToPrevious = (e: any) => {
    e.stopPropagation();
    const isFirstSlide = currentIndex === 0;
    const _currentIndex = isFirstSlide
      ? slides.length - 1
      : currentIndex - 1;
    setCurrentIndex(_currentIndex);
    setCurrentIndicator(Math.trunc(_currentIndex / NUMBER_OF_IMAGES_PER_SLIDE));
  };

  const goToNext = (e: any) => {
    e.stopPropagation();
    let _currentIndex;
    const isLastSlide = currentIndex === slides.length - 1;
    if (isLastSlide) {
      _currentIndex = 0;
    } else {
      _currentIndex = currentIndex + 1;
    }
    setCurrentIndex(_currentIndex);
    setCurrentIndicator(Math.trunc(_currentIndex / NUMBER_OF_IMAGES_PER_SLIDE));
  };

  const ArrowComponent = (props: IArrowComponent) => {
    const { onClick, style, children } = props;
    return (
      <Box onClick={onClick} style={style}>
        {children}
      </Box>);
  };

  const handleOpenNewPage = async (fileName?: string) => {
    const imageURL = id && await getOriginalWatermarkImage(id, fileName);
    window.open(imageURL, '_blank');
  };

  const handleCloseModal = (e:any) => {
    e.stopPropagation();
    setOpenModal(false);
    document.body.style.overflowY = 'visible';
  };

  return (
    <>
      <Box onClick={handleCloseModal} sx={modalOverlayStyle}>
        <Box sx={modalContentStyle}>
          {slides.length > 1 &&
            <>
              <ArrowComponent onClick={goToPrevious}
                style={matchesSMbreakpoint
                  ? leftArrowStylesMobileModal
                  : leftArrowStylesModal}>
                {/* ❰ */}
                <ChevronLeftIcon
                  fontSize='large'
                  sx={{
                    backgroundColor: '#1622aa',
                    border: 'solid 2px #1622aa',
                    borderRadius: '50%',
                    padding: 0.5
                  }}
                />
              </ArrowComponent>
              <ArrowComponent onClick={goToNext} style={matchesSMbreakpoint
                ? rightArrowStylesMobileModal
                : rightArrowStylesModal}>
                {/* ❱ */}
                <ChevronRigthIcon
                  fontSize='large'
                  sx={{
                    backgroundColor: '#1622aa',
                    border: 'solid 2px #1622aa',
                    borderRadius: '50%',
                    padding: 0.5
                  }}
                />
              </ArrowComponent>
            </>
          }
          <Box sx={matchesSMbreakpoint
            ? ImageContainerMobile
            : ImageContainer}>
            <img
              onClick={(e) => e.stopPropagation()}
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                borderRadius: '5px',
              }}
              src={slides[currentIndex].url}
              alt='Selected Image' />
            {imageButtons && <>
              <IconButton disableRipple sx={openTabButtonStyle}
                onClick={(e) => {
                  e.stopPropagation();
                  handleOpenNewPage(slides[currentIndex]?.title);
                }}>
                <OpenInNewIcon />
              </IconButton>
              <IconButton disableRipple sx={closeButtonStyle}
                onClick={handleCloseModal}>
                <CloseIcon />
              </IconButton>
            </>}

          </Box>
        </Box>
      </Box>
    </>
  );
};

export default ImageModalGallery;
